export function mapClaimingFor(claimingFor) {
  const options = [];

  if (claimingFor.loss) {
    options.push('loss');
  }
  if (claimingFor.theft) {
    options.push('theft');
  }
  if (claimingFor.damage) {
    options.push('damage');
  }
  if (claimingFor.delay) {
    options.push('delay');
  }

  return options.join(',');
}

export function nullItem(item) {
  return !!item;
}




// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/sharedMapper.js